import { useContent } from '../data/ContentContext';
import { FeatureIcon } from '../components/icons';
import { AutomationPipeline } from '../components/AutomationPipeline';
import './featurePage.css';
import './AutomationPage.css';

export function AutomationPage() {
  const { automationContent, automationQuickApps } = useContent();
  const { examples } = automationContent;

  return (
    <div className="page">
      {/* Hero — centered headline */}
      <section className="auto-hero">
        <h1 className="auto-hero__title">
          <span className="auto-hero__gradient">Automation Module</span>
          <span className="auto-hero__plain">is here.</span>
        </h1>
        <p className="auto-hero__summary">
          Our latest state of the automation workflow and tools. All work
          including organizing information, data visualizing and report
          distribution is completed automatically.
        </p>
      </section>

      {/* Automation pipeline animation */}
      <AutomationPipeline className="auto-pipeline" />

      {/* Real examples */}
      <section className="feat-card">
        <h2 className="feat-card__title">
          <FeatureIcon name="clipboard" /> Reporting Automation
        </h2>
        <p className="qa-summary">
          This part is based on the fully automated workflow and intelligent
          agent set up in the DAP-AI backend. Some email summaries suitable for
          daily repetition work.
        </p>
        <div className="auto-examples">
          {examples.map((ex) => (
            <div className="auto-ex" key={ex.title}>
              <div className="auto-ex__head">
                <span className="auto-ex__icon" aria-hidden>
                  <FeatureIcon name={ex.icon} size={18} />
                </span>
                {ex.title}
              </div>
              <div className="auto-ex__rows">
                {ex.rows.map((row) => (
                  <p key={row.label}>
                    <strong>{row.label}:</strong> {row.text}
                  </p>
                ))}
              </div>
              <span className="auto-ex__saving">
                <FeatureIcon name="clock" size={15} /> {ex.saving}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* SQM Self-develop Automation Tools */}
      <section className="feat-card">
        <h2 className="feat-card__title">
          <FeatureIcon name="grid" /> SQM Self-develop Automation Tools
        </h2>
        <p className="qa-summary">
          This part is jointly developed by the mechanical SQM team using Amazon
          Quick Build apps, which are suitable for individuals to use on their
          own PCs to quickly analyze data and understand the management process
          of mechanical parts.
        </p>
        <div className="qa-grid">
          {automationQuickApps.map((app) => (
            <div className="qa-card" key={app.title}>
              <h3 className="qa-card__title">{app.title}</h3>
              <p className="qa-card__desc">{app.description}</p>
              <a
                className="qa-card__link"
                href={app.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FeatureIcon name="link" size={16} />
                {app.linkLabel}
              </a>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
